import { render, staticRenderFns } from "./zip-code.vue?vue&type=template&id=50b22672"
import script from "./zip-code.vue?vue&type=script&lang=js"
export * from "./zip-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports